import { useMutation } from '@tanstack/react-query'

import { useStandardService } from '../../../hooks/useStandardService'
import { useNavigationParams } from '../../../system/useNavigationParams'
import { fetchFromService } from '../fetchFromService'

type TriggerProps = {
  specId: string
  /** Date the spec to export has to be active on, its from date included. */
  at: string
}

/**
 * Fetches the Excel document of a reconciliation spec straight from the connected
 * component, which owns the configuration on the standard branch. The configuration
 * component, and therefore its conversion service, is not available there.
 */
export const useMutateFetchStandardReconciliationSpecExcel = () => {
  const service = useStandardService()
  const { layer } = useNavigationParams()

  return useMutation({
    mutationFn: async ({ specId, at }: TriggerProps) => {
      const response = await fetchFromService({
        serviceConfig: service.api.OpenAPI,
        serviceName: 'standard',
        path: `/configuration/reconciliationspec/excel/${encodeURIComponent(at)}/${encodeURIComponent(specId)}/latest`,
        method: 'GET',
        // TODO: Add proper layering support once the standard service supports it
        headers: layer.tenantId ? { 'x-tenant-id': layer.tenantId } : undefined,
        errorMessage: 'Failed to fetch the reconciliation-spec Excel document',
      })

      return await response.blob()
    },
  })
}
